var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/core-js/library/modules/_html.js
// module id = 629
// module chunks = 0